<template>
  <canvas v-bind:height="timeScrollBarCanvasHeightPx"></canvas>
</template>

<script>
import timelineCanvas from './mixins/timelineCanvas.js';
import canvasUtils from './modules/canvasUtils.js';
import Color from '../../../modules/Color.js';

const timelineScrollBarColor = new Color(187, 187, 187);

export default {
  mixins: [
    timelineCanvas,
  ],

  watch: {
    timeScrollBarDomRect() { this.$_setDirty(true); },
    timeScrollBarCanvasHeightPx() { this.$_setDirty(true); },
  },

  props: {
    timeScrollBarDomRect:        { type: DOMRect },
    timeScrollBarCanvasHeightPx: { type: Number },
  },

  methods: {
    /* public */
    draw() {
      this.$_draw(() => {
        canvasUtils.drawRect(
          this.$data.$_timelineCanvasContext,
          this.timeScrollBarDomRect,
          {
            fill: true,
            fillStyle: timelineScrollBarColor.styleString,
          },
        );
      });
    },
  }
};
</script>